
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import * as Sentry from '@sentry/angular-ivy';

@Injectable()
export class DevAccessInterceptor implements HttpInterceptor {

  constructor(

  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let req = request;
    if (request.url.includes('-dev.')) {
      req = request.clone({
        headers: request.headers.set('X-API-Key', 'C4G_X9mK7pL2nQ5vB8rT4wY1aZ6cF3jH0sD_2025_DEV_ACCESS')
      })
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // ✅ أرسل الـ API error لـ Sentry
        Sentry.captureException(error, {
          tags: {
            type: 'api_error',
            url: request.url,
            method: request.method,
            status: error.status,
          },
          extra: {
            requestUrl: request.url,
            requestMethod: request.method,
            requestBody: request.body,
            responseStatus: error.status,
            responseError: error.error,
            responseMessage: error.message,
          },
        });

        // ✅ اطبع في Console برضه

        return throwError(() => error);
      })
    );

    // catchError((error) => {
    //   Sentry.captureException(error);
    //   throw error;
    // });


    return next.handle(req);
  }
}